var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum2Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.9238,
    r: 16,
    fill: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2285 22.9238V21.6488C15.2435 18.9488 17.0285 16.8638 17.0285 15.1538C17.0285 14.0288 16.4285 13.3538 15.3635 13.3538C14.5535 13.3538 13.8935 13.8788 13.3235 14.4938L12.1235 13.2938C13.1435 12.1988 14.1335 11.6138 15.6485 11.6138C17.7485 11.6138 19.1435 12.9638 19.1435 15.0338C19.1435 17.0438 17.4785 19.2038 15.4535 21.1838C16.0085 21.1238 16.7435 21.0638 17.2685 21.0638H19.6685V22.9238H12.2285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum2Blue);
export default __webpack_public_path__ + "static/media/icon_circleNum_2_blue.5fd743e2b68bb272d86882154e3d16a0.svg";
export { ForwardRef as ReactComponent };